let validateBknNum = (str) => {
  const pesosBkn = [1, 3, 5, 7, 11, 2, 13, 19, 23, 31, 29, 17]
  const twoLastNums = str.substring(9, 11)
  const officeAcc = str.substring(0, 9)
  let dcBkn = 0

  const officeAcc12 = addElemsToLeft(officeAcc, '0', 12)

  for (var i = 0; i < officeAcc12.length; i++) {
    const digit = officeAcc12.charAt(i)
    dcBkn = dcBkn + (pesosBkn[i] * digit)
  }

  dcBkn = (dcBkn % 99)

  let strcbankia = ''

  if (dcBkn < 10) {
    strcbankia = '0' + dcBkn
  } else {
    strcbankia = '' + dcBkn
  }
  return twoLastNums === strcbankia
}

let addElemsToLeft = (str, toAdd, length) => {
  let toReturn = ''
  for (var i = 0; i < length - str.length; i++) {
    toReturn += toAdd
  }
  return toReturn + str
}

export default validateBknNum
